import { css } from "vite-css-in-js"
import { computed, ref, Teleport } from "vue"
import { defineComponent, useTimeout, type ReactiveComponent } from "vue-utils"
import LoadingSpinner from "./LoadingSpinner"

const backgroundStyles = css`
	color: white;

	font-size: 1.25rem;
	position: fixed;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;

	display: flex;
	align-items: center;
	justify-content: center;

	transition: background-color 0.5s;

	z-index: 50;

	.busy {
		opacity: 0.95;
	}
`

const FullScreenLoading: ReactiveComponent = () => {
	const visible = ref(false)
	const usedOpacity = computed(() => (visible.value ? 0.25 : 0))

	useTimeout(100, () => (visible.value = true))

	return () => (
		<Teleport to="body">
			<div class={backgroundStyles} style={{ backgroundColor: `rgba(0, 0, 0, ${usedOpacity.value})` }}>
				{visible.value && <LoadingSpinner />}
			</div>
		</Teleport>
	)
}

export default defineComponent(FullScreenLoading)
